/**
 * @generated SignedSource<<ef233bf78ae3ac925f558df3f43ca229>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserGreekType = "ALPHA" | "BETA" | "DELTA" | "GAMMA";
export type IntegratePageTypeQuery$variables = {};
export type IntegratePageTypeQuery$data = {
  readonly user: {
    readonly id: string;
    readonly internalAttributes: {
      readonly greekType: UserGreekType | null;
      readonly primaryConferenceCallProvider: string | null;
    } | null;
  };
  readonly users: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firstName: string;
        readonly id: string;
      };
    }>;
  } | null;
  readonly viewer: {
    readonly integrations: {
      readonly google: {
        readonly id: string;
      } | null;
    };
    readonly user: {
      readonly id: string;
    };
  };
};
export type IntegratePageTypeQuery = {
  response: IntegratePageTypeQuery$data;
  variables: IntegratePageTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GoogleUserNode",
      "kind": "LinkedField",
      "name": "google",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "users",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryConferenceCallProvider",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "greekType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegratePageTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegratePageTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserInternalAttributes",
            "kind": "LinkedField",
            "name": "internalAttributes",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b71a69f453eeca2699243181e37ef7e",
    "id": null,
    "metadata": {},
    "name": "IntegratePageTypeQuery",
    "operationKind": "query",
    "text": "query IntegratePageTypeQuery {\n  viewer {\n    user {\n      id\n    }\n    integrations {\n      google {\n        id\n      }\n    }\n    id\n  }\n  users {\n    edges {\n      node {\n        id\n        firstName\n      }\n    }\n  }\n  user {\n    id\n    internalAttributes {\n      primaryConferenceCallProvider\n      greekType\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "024ec7b23dcb2be80eefb1aa0b1b8369";

export default node;
